module.exports = __webpack_public_path__ + "856d37de73f1e4ab41d26eec864a673e.png";